import React from 'react';
import Extra from '../components/Extra';
import Seo from '../components/Seo';
import Layout from '../components/Layout';

const Contact = () => (
  <Layout>
    <Seo title="Contact Us" />
    <Extra />
  </Layout>
);

export default Contact;
